import { jsx as n, jsxs as v } from "react/jsx-runtime";
import { createContext as at, useContext as ct, useState as F, useEffect as T, useRef as j, useCallback as J, useMemo as G } from "react";
import { substituteRequestFields as ut, requestSignature as dt, fetchOptions as yt, substituteTokens as vt, replayPathTo as pt, createAnswerContext as ht, personalizeScreen as mt, validatePresentAnswers as ft, computeNext as me, validateAnswerValue as gt, resolveNavigationListTarget as _t } from "@shift-software/survey-sdk";
import "adp-web-components/components/shift-booking-calendar";
function je(e) {
  const t = e.trim().replace(/^#/, "");
  if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(t)) return null;
  const r = t.length === 3 ? t.split("").map((i) => i + i).join("") : t.slice(0, 6);
  return [
    parseInt(r.slice(0, 2), 16),
    parseInt(r.slice(2, 4), 16),
    parseInt(r.slice(4, 6), 16)
  ];
}
function qe([e, t, r]) {
  const i = (u) => Math.max(0, Math.min(255, Math.round(u))).toString(16).padStart(2, "0");
  return `#${i(e)}${i(t)}${i(r)}`;
}
function bt(e, t) {
  return [e[0] * t, e[1] * t, e[2] * t];
}
function Nt([e, t, r]) {
  const i = (u) => {
    const l = u / 255;
    return l <= 0.03928 ? l / 12.92 : Math.pow((l + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * i(e) + 0.7152 * i(t) + 0.0722 * i(r);
}
function wt(e) {
  const t = {}, r = e != null && e.primaryColor ? je(e.primaryColor) : null;
  r && (t["--survey-primary"] = qe(r), t["--survey-primary-hover"] = qe(bt(r, 0.82)), t["--survey-primary-contrast"] = Nt(r) > 0.45 ? "#111111" : "#ffffff");
  const i = e != null && e.secondaryColor ? je(e.secondaryColor) : null;
  return i && (t["--survey-accent"] = qe(i)), t;
}
const Me = at(null), qt = Me.Provider;
function R() {
  const e = ct(Me);
  if (!e)
    throw new Error(
      "useSurveyContext must be used inside <SurveyRenderer>. Question components rely on survey state from the enclosing provider."
    );
  return e;
}
function m(e, t, r) {
  if (e == null) return "";
  if (typeof e == "string") return e;
  if (e[t]) return e[t];
  if (r && e[r]) return e[r];
  const i = Object.keys(e);
  return i.length > 0 ? e[i[0]] : "";
}
const He = {
  direction: "ltr",
  strings: {
    next: "Next",
    back: "Back",
    submit: "Submit",
    submitting: "Submitting…",
    loading: "Loading survey…",
    thankYou: "Thank you.",
    selectPlaceholder: "Select…",
    clearSignature: "Clear",
    noScreens: "No screens in this survey.",
    unsupportedQuestion: "Unsupported question type:",
    couldNotSubmit: "Could not submit:",
    sendingAnswers: "Sending your answers…",
    submitRetryError: "We could not send your answers. Check your connection and try again.",
    submitFailedError: "Something went wrong and your answers could not be sent. Please try again later.",
    alreadyAnsweredTitle: "Already answered",
    alreadyAnsweredBody: "We have already received your answers to this survey. Thank you.",
    surveyClosedTitle: "This survey has closed",
    surveyClosedBody: "It is no longer accepting answers. Thank you for your time.",
    requiredError: "This question is required.",
    minLengthError: "Must be at least {n} characters.",
    maxLengthError: "Must be at most {n} characters.",
    patternError: "Does not match the required format.",
    minError: "Must be at least {n}.",
    maxError: "Must be at most {n}.",
    rangeError: "Must be between {min} and {max}.",
    minSelectedError: "Select at least {n} option(s).",
    maxSelectedError: "Select at most {n} option(s).",
    invalidAnswerError: "Please check this answer.",
    loadingOptions: "Loading options…",
    optionsLoadError: "Could not load the options.",
    retry: "Retry",
    yes: "Yes",
    no: "No",
    fileRecordedName: "Recorded file details: {name}",
    language: "Language"
  }
}, St = {
  direction: "rtl",
  strings: {
    next: "التالي",
    back: "رجوع",
    submit: "إرسال",
    submitting: "جاري الإرسال…",
    loading: "جاري تحميل الاستبيان…",
    thankYou: "شكراً لك.",
    selectPlaceholder: "اختر…",
    clearSignature: "مسح",
    noScreens: "لا توجد شاشات في هذا الاستبيان.",
    unsupportedQuestion: "نوع سؤال غير مدعوم:",
    couldNotSubmit: "تعذر الإرسال:",
    sendingAnswers: "جارٍ إرسال إجاباتك…",
    submitRetryError: "تعذّر إرسال إجاباتك. تحقق من اتصالك بالإنترنت وحاول مرة أخرى.",
    submitFailedError: "حدث خطأ ما وتعذّر إرسال إجاباتك. يرجى المحاولة لاحقاً.",
    alreadyAnsweredTitle: "تمت الإجابة مسبقاً",
    alreadyAnsweredBody: "لقد استلمنا إجاباتك على هذا الاستبيان. شكراً لك.",
    surveyClosedTitle: "تم إغلاق هذا الاستبيان",
    surveyClosedBody: "لم يعد يستقبل إجابات. شكراً لوقتك.",
    requiredError: "هذا السؤال مطلوب.",
    minLengthError: "يجب ألا يقل عن {n} حرفاً.",
    maxLengthError: "يجب ألا يزيد عن {n} حرفاً.",
    patternError: "لا يطابق التنسيق المطلوب.",
    minError: "يجب ألا يقل عن {n}.",
    maxError: "يجب ألا يزيد عن {n}.",
    rangeError: "يجب أن يكون بين {min} و {max}.",
    minSelectedError: "اختر {n} خيارات على الأقل.",
    maxSelectedError: "اختر {n} خيارات كحد أقصى.",
    invalidAnswerError: "يرجى التحقق من هذه الإجابة.",
    loadingOptions: "جاري تحميل الخيارات…",
    optionsLoadError: "تعذر تحميل الخيارات.",
    retry: "إعادة المحاولة",
    yes: "نعم",
    no: "لا",
    fileRecordedName: "تم تسجيل تفاصيل الملف: {name}",
    language: "اللغة"
  }
}, Lt = {
  direction: "rtl",
  strings: {
    next: "دواتر",
    back: "گەڕانەوە",
    submit: "ناردن",
    submitting: "دەنێردرێت…",
    loading: "ڕاپرسی باردەکرێت…",
    thankYou: "سوپاس.",
    selectPlaceholder: "هەڵبژێرە…",
    clearSignature: "سڕینەوە",
    noScreens: "هیچ پەڕەیەک لەم ڕاپرسییەدا نییە.",
    unsupportedQuestion: "جۆری پرسیاری پشتگیری نەکراو:",
    couldNotSubmit: "ناردن سەرکەوتوو نەبوو:",
    sendingAnswers: "وەڵامەکانت دەنێردرێن…",
    submitRetryError: "نەتوانرا وەڵامەکانت بنێردرێن. پەیوەندی ئینتەرنێتەکەت بپشکنە و دووبارە هەوڵ بدەرەوە.",
    submitFailedError: "هەڵەیەک ڕوویدا و وەڵامەکانت نەنێردران. تکایە دواتر هەوڵ بدەرەوە.",
    alreadyAnsweredTitle: "پێشتر وەڵام دراوەتەوە",
    alreadyAnsweredBody: "وەڵامەکانی تۆمان بۆ ئەم ڕاپرسییە وەرگرتووە. سوپاس.",
    surveyClosedTitle: "ئەم ڕاپرسییە داخراوە",
    surveyClosedBody: "چیتر وەڵام وەرناگرێت. سوپاس بۆ کاتەکەت.",
    requiredError: "ئەم پرسیارە پێویستە.",
    minLengthError: "دەبێت لانیکەم {n} پیت بێت.",
    maxLengthError: "دەبێت زۆرترین {n} پیت بێت.",
    patternError: "لەگەڵ فۆرماتی داواکراودا یەک ناگرێتەوە.",
    minError: "دەبێت لانیکەم {n} بێت.",
    maxError: "دەبێت زۆرترین {n} بێت.",
    rangeError: "دەبێت لە نێوان {min} و {max} بێت.",
    minSelectedError: "لانیکەم {n} هەڵبژاردە هەڵبژێرە.",
    maxSelectedError: "زۆرترین {n} هەڵبژاردە هەڵبژێرە.",
    invalidAnswerError: "تکایە ئەم وەڵامە بپشکنە.",
    loadingOptions: "هەڵبژاردەکان باردەکرێن…",
    optionsLoadError: "نەتوانرا هەڵبژاردەکان باربکرێن.",
    retry: "دووبارە هەوڵبدەوە",
    yes: "بەڵێ",
    no: "نەخێر",
    fileRecordedName: "زانیاری فایل تۆمارکرا: {name}",
    language: "زمان"
  }
}, xt = {
  direction: "ltr",
  strings: {
    next: "Далее",
    back: "Назад",
    submit: "Отправить",
    submitting: "Отправка…",
    loading: "Загрузка опроса…",
    thankYou: "Спасибо.",
    selectPlaceholder: "Выберите…",
    clearSignature: "Очистить",
    noScreens: "В этом опросе нет экранов.",
    unsupportedQuestion: "Неподдерживаемый тип вопроса:",
    couldNotSubmit: "Не удалось отправить:",
    sendingAnswers: "Отправляем ваши ответы…",
    submitRetryError: "Не удалось отправить ваши ответы. Проверьте подключение и попробуйте ещё раз.",
    submitFailedError: "Что-то пошло не так, и ваши ответы не удалось отправить. Попробуйте позже.",
    alreadyAnsweredTitle: "Ответы уже получены",
    alreadyAnsweredBody: "Мы уже получили ваши ответы на этот опрос. Спасибо.",
    surveyClosedTitle: "Опрос закрыт",
    surveyClosedBody: "Он больше не принимает ответы. Спасибо за уделённое время.",
    requiredError: "Этот вопрос обязателен.",
    minLengthError: "Не менее {n} символов.",
    maxLengthError: "Не более {n} символов.",
    patternError: "Не соответствует требуемому формату.",
    minError: "Не менее {n}.",
    maxError: "Не более {n}.",
    rangeError: "Должно быть от {min} до {max}.",
    minSelectedError: "Выберите не менее {n} вариантов.",
    maxSelectedError: "Выберите не более {n} вариантов.",
    invalidAnswerError: "Пожалуйста, проверьте этот ответ.",
    loadingOptions: "Загрузка вариантов…",
    optionsLoadError: "Не удалось загрузить варианты.",
    retry: "Повторить",
    yes: "Да",
    no: "Нет",
    fileRecordedName: "Записаны сведения о файле: {name}",
    language: "Язык"
  }
}, kt = { en: He, ar: St, ku: Lt, ru: xt }, Et = {
  en: "English",
  ar: "العربية",
  ku: "کوردی",
  ru: "Русский",
  tr: "Türkçe",
  fa: "فارسی"
};
function At(e) {
  const t = Et[e];
  if (t) return t;
  try {
    const i = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (i && i !== e) return i;
  } catch {
  }
  return e;
}
function K(e, t) {
  return t ? e.replace(
    /\{(\w+)\}/g,
    (r, i) => i in t ? String(t[i]) : r
  ) : e;
}
function Ct(e, t, r) {
  const i = { ...kt, ...r ?? {} };
  return i[e] ?? (t ? i[t] : void 0) ?? i.en ?? He;
}
const Tt = "adp-surveys", Rt = 1;
function Bt(e = {}) {
  const t = typeof window < "u", r = t && window.parent !== window, i = e.enabled ?? r, u = e.target ?? (t ? window.parent : null), l = e.targetOrigin ?? "*";
  if (!i || !u)
    return {
      loaded: () => {
      },
      screenChanged: () => {
      },
      completed: () => {
      },
      error: () => {
      },
      resize: () => {
      }
    };
  const o = (c, p) => {
    const g = {
      source: Tt,
      version: Rt,
      type: c,
      payload: p
    };
    try {
      u.postMessage(g, l);
    } catch {
    }
  };
  return {
    loaded: () => o("survey:loaded", {}),
    screenChanged: (c) => o("survey:screen-changed", { screenId: c }),
    completed: (c) => o("survey:completed", c),
    error: (c) => o("survey:error", { message: c }),
    resize: (c) => o("survey:resize", { height: c })
  };
}
function ke(e) {
  return `adp-surveys:resume:${e}`;
}
function It(e, t) {
  try {
    const r = e.getItem(ke(t));
    if (!r) return null;
    const i = JSON.parse(r);
    return !i || typeof i != "object" || !i.answers ? null : i;
  } catch {
    return null;
  }
}
function Ot(e, t, r) {
  try {
    const i = { ...r, savedAt: Date.now() };
    e.setItem(ke(t), JSON.stringify(i));
  } catch {
  }
}
function Qt(e, t) {
  try {
    e.removeItem(ke(t));
  } catch {
  }
}
const fe = /* @__PURE__ */ new Map();
function un() {
  fe.clear();
}
function $t({
  question: e,
  Component: t
}) {
  const { locale: r, schema: i, ui: u, answerContext: l, registerSourcedOptions: o } = R(), c = ut(e.optionsSource, l, r), p = e.id, g = `${r}|${dt(c, r)}`, [d, y] = F(() => {
    const C = fe.get(g);
    return C ? { status: "ready", options: C } : { status: "loading" };
  }), [a, _] = F(0);
  T(() => {
    const C = fe.get(g);
    if (C) {
      y({ status: "ready", options: C });
      return;
    }
    let b = !1;
    return y({ status: "loading" }), yt(c, { locale: r }).then((x) => {
      fe.set(g, x), b || y({ status: "ready", options: x });
    }).catch((x) => {
      b || y({ status: "error", message: x.message ?? String(x) });
    }), () => {
      b = !0;
    };
  }, [g, a]), T(() => {
    d.status === "ready" && p && o(p, d.options);
  }, [d, p, o]);
  const N = e.title, w = N ? /* @__PURE__ */ n("span", { className: "survey-question__label", children: m(N, r, i.defaultLocale) }) : null;
  if (d.status === "loading")
    return /* @__PURE__ */ v("div", { className: "survey-question survey-question--options-loading", role: "status", children: [
      w,
      /* @__PURE__ */ n("p", { className: "survey-question__options-status", children: u.loadingOptions })
    ] });
  if (d.status === "error")
    return /* @__PURE__ */ v("div", { className: "survey-question survey-question--options-error", children: [
      w,
      /* @__PURE__ */ n("p", { className: "survey-question__options-status", role: "alert", children: u.optionsLoadError }),
      /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          className: "survey-button survey-button--retry",
          onClick: () => _((C) => C + 1),
          children: u.retry
        }
      )
    ] });
  const A = e.type === "navigationList", B = {
    ...e,
    options: d.options.map((C) => ({
      id: C.id,
      label: { [r]: C.label },
      ...A && c.nextScreen ? { nextScreen: c.nextScreen } : {}
    }))
  };
  return /* @__PURE__ */ n(t, { question: B });
}
function Ft({
  question: e,
  registry: t
}) {
  const { ui: r } = R(), i = e.type, u = i ? t[i] : void 0;
  if (!u)
    return /* @__PURE__ */ n("div", { className: "survey-question survey-question--unknown", children: /* @__PURE__ */ v("em", { children: [
      r.unsupportedQuestion,
      " ",
      String(i ?? "missing")
    ] }) });
  const l = Array.isArray(e.options) && e.options.length > 0;
  return e.optionsSource != null && !l ? /* @__PURE__ */ n($t, { question: e, Component: u }) : /* @__PURE__ */ n(u, { question: e });
}
function Dt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = i[l] ?? "";
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--text", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${l}`, children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "input",
      {
        id: `q-${l}`,
        className: "survey-question__input",
        type: "text",
        value: g,
        required: p,
        onChange: (d) => u(l, d.target.value)
      }
    )
  ] });
}
function Pt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = Number(e.min ?? 0), d = Number(e.max ?? 10), y = e.lowLabel, a = e.highLabel, _ = i[l], N = [];
  for (let w = g; w <= d; w++) N.push(w);
  return /* @__PURE__ */ v("fieldset", { className: "survey-question survey-question--nps", children: [
    /* @__PURE__ */ v("legend", { className: "survey-question__label", children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n("div", { className: "survey-question__nps-scale", role: "radiogroup", children: N.map((w) => {
      const A = _ === w;
      return /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          role: "radio",
          "aria-checked": A,
          className: "survey-question__nps-step" + (A ? " survey-question__nps-step--selected" : ""),
          onClick: () => u(l, w),
          children: w
        },
        w
      );
    }) }),
    (y || a) && /* @__PURE__ */ v("div", { className: "survey-question__nps-labels", children: [
      /* @__PURE__ */ n("span", { children: y ? m(y, t, r.defaultLocale) : "" }),
      /* @__PURE__ */ n("span", { children: a ? m(a, t, r.defaultLocale) : "" })
    ] })
  ] });
}
function Vt({ question: e }) {
  const { locale: t, schema: r, answers: i } = R(), u = e.id, l = i[u], o = e.title, c = e.help, p = e.options ?? [], g = (d, y) => {
    const a = {
      questionId: u,
      option: {
        id: y.id,
        nextScreen: y.nextScreen
      }
    };
    d.currentTarget.dispatchEvent(
      new CustomEvent("survey:navigationListSelect", {
        detail: a,
        bubbles: !0
      })
    );
  };
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--navlist", children: [
    /* @__PURE__ */ n("div", { className: "survey-question__label", children: m(o, t, r.defaultLocale) }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n("ul", { className: "survey-navlist", role: "radiogroup", "aria-description": "Selecting an option navigates to the next screen.", children: p.map((d) => {
      const y = d.id, a = d.label, _ = l === y;
      return /* @__PURE__ */ n("li", { className: "survey-navlist__row", children: /* @__PURE__ */ v(
        "button",
        {
          type: "button",
          className: _ ? "survey-navlist__button survey-navlist__button--selected" : "survey-navlist__button",
          "aria-pressed": _,
          onClick: (N) => g(N, d),
          children: [
            /* @__PURE__ */ n("span", { className: "survey-navlist__label", children: m(a, t, r.defaultLocale) }),
            /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "survey-navlist__chevron", children: "›" })
          ]
        }
      ) }, y);
    }) })
  ] });
}
function jt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = e.placeholder, g = !!e.required, d = e.minLength, y = e.maxLength, a = i[l] ?? "";
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--paragraph", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${l}`, children: [
      m(o, t, r.defaultLocale),
      g && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "textarea",
      {
        id: `q-${l}`,
        className: "survey-question__textarea",
        value: a,
        required: g,
        rows: 5,
        minLength: d,
        maxLength: y,
        placeholder: p ? m(p, t, r.defaultLocale) : void 0,
        onChange: (_) => u(l, _.target.value)
      }
    )
  ] });
}
function zt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = e.min, d = e.max, y = e.step, a = e.unit, _ = i[l], N = _ == null ? "" : String(_);
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--number", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${l}`, children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ v("div", { className: "survey-question__number-wrap", children: [
      /* @__PURE__ */ n(
        "input",
        {
          id: `q-${l}`,
          className: "survey-question__input",
          type: "number",
          value: N,
          required: p,
          min: g,
          max: d,
          step: y,
          onChange: (w) => {
            const A = w.target.value;
            u(l, A === "" ? null : Number(A));
          }
        }
      ),
      a && /* @__PURE__ */ n("span", { className: "survey-question__unit", children: m(a, t, r.defaultLocale) })
    ] })
  ] });
}
function Mt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = Number(e.max ?? 5), d = i[l], y = [];
  for (let a = 1; a <= g; a++) y.push(a);
  return /* @__PURE__ */ v("fieldset", { className: "survey-question survey-question--rating", children: [
    /* @__PURE__ */ v("legend", { className: "survey-question__label", children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n("div", { className: "survey-question__rating-scale", role: "radiogroup", children: y.map((a) => {
      const _ = typeof d == "number" && a <= d;
      return /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          role: "radio",
          "aria-checked": d === a,
          "aria-label": `${a}`,
          className: "survey-question__rating-star" + (_ ? " survey-question__rating-star--selected" : ""),
          onClick: () => u(l, a),
          children: /* @__PURE__ */ n("span", { "aria-hidden": "true", children: "★" })
        },
        a
      );
    }) })
  ] });
}
function Ht({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = e.options ?? [], d = i[l];
  return /* @__PURE__ */ v("fieldset", { className: "survey-question survey-question--single", children: [
    /* @__PURE__ */ v("legend", { className: "survey-question__label", children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n("div", { className: "survey-question__options", children: g.map((y) => /* @__PURE__ */ v("label", { className: "survey-question__option", children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: "radio",
          name: `q-${l}`,
          value: y.id,
          checked: d === y.id,
          onChange: () => u(l, y.id)
        }
      ),
      /* @__PURE__ */ n("span", { children: m(y.label, t, r.defaultLocale) })
    ] }, y.id)) })
  ] });
}
function Ut({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = e.options ?? [], d = e.maxSelected, y = i[l] ?? [], a = (_) => {
    if (y.includes(_)) {
      u(l, y.filter((w) => w !== _));
      return;
    }
    d !== void 0 && y.length >= d || u(l, [...y, _]);
  };
  return /* @__PURE__ */ v("fieldset", { className: "survey-question survey-question--multi", children: [
    /* @__PURE__ */ v("legend", { className: "survey-question__label", children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n("div", { className: "survey-question__options", children: g.map((_) => {
      const N = y.includes(_.id);
      return /* @__PURE__ */ v("label", { className: "survey-question__option", children: [
        /* @__PURE__ */ n(
          "input",
          {
            type: "checkbox",
            checked: N,
            onChange: () => a(_.id)
          }
        ),
        /* @__PURE__ */ n("span", { children: m(_.label, t, r.defaultLocale) })
      ] }, _.id);
    }) })
  ] });
}
function Wt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u, ui: l } = R(), o = e.id, c = e.title, p = e.help, g = !!e.required, d = e.options ?? [], y = e.placeholder, a = i[o] ?? "", _ = y ? m(y, t, r.defaultLocale) : l.selectPlaceholder;
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--dropdown", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${o}`, children: [
      m(c, t, r.defaultLocale),
      g && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    p && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(p, t, r.defaultLocale) }),
    /* @__PURE__ */ v(
      "select",
      {
        id: `q-${o}`,
        className: "survey-question__select",
        value: a,
        required: g,
        onChange: (N) => u(o, N.target.value || null),
        children: [
          /* @__PURE__ */ n("option", { value: "", children: _ }),
          d.map((N) => /* @__PURE__ */ n("option", { value: N.id, children: m(N.label, t, r.defaultLocale) }, N.id))
        ]
      }
    )
  ] });
}
function Yt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = e.minDate, d = e.maxDate, y = i[l] ?? "";
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--date", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${l}`, children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "input",
      {
        id: `q-${l}`,
        className: "survey-question__input",
        type: "date",
        value: y,
        required: p,
        min: g,
        max: d,
        onChange: (a) => u(l, a.target.value || null)
      }
    )
  ] });
}
function Gt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u } = R(), l = e.id, o = e.title, c = e.help, p = !!e.required, g = e.minDateTime, d = e.maxDateTime, y = i[l] ?? "", a = (_) => {
    if (!_) return;
    const N = _.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
    return (N == null ? void 0 : N[1]) ?? void 0;
  };
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--datetime", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${l}`, children: [
      m(o, t, r.defaultLocale),
      p && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    c && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(c, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "input",
      {
        id: `q-${l}`,
        className: "survey-question__input",
        type: "datetime-local",
        value: a(y) ?? "",
        required: p,
        min: a(g),
        max: a(d),
        onChange: (_) => u(l, _.target.value || null)
      }
    )
  ] });
}
function Jt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u, ui: l } = R(), o = e.id, c = e.title, p = e.help, g = !!e.required, d = e.acceptedTypes, y = j(null), a = i[o], _ = d && d.length > 0 ? d.join(",") : void 0;
  return /* @__PURE__ */ v("div", { className: "survey-question survey-question--file", children: [
    /* @__PURE__ */ v("label", { className: "survey-question__label", htmlFor: `q-${o}`, children: [
      m(c, t, r.defaultLocale),
      g && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    p && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(p, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "input",
      {
        ref: y,
        id: `q-${o}`,
        className: "survey-question__file",
        type: "file",
        required: g,
        accept: _,
        onChange: (N) => {
          var A;
          const w = (A = N.target.files) == null ? void 0 : A[0];
          if (!w) {
            u(o, null);
            return;
          }
          u(o, { name: w.name, size: w.size, type: w.type });
        }
      }
    ),
    (a == null ? void 0 : a.name) && /* @__PURE__ */ n("p", { className: "survey-question__file-name", children: K(l.fileRecordedName, { name: a.name }) })
  ] });
}
const Se = 480, Le = 160;
function Zt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u, ui: l } = R(), o = e.id, c = e.title, p = e.help, g = !!e.required, d = j(null), [y, a] = F(!1), [_, N] = F(!!i[o]), w = () => {
    var b;
    return ((b = d.current) == null ? void 0 : b.getContext("2d")) ?? null;
  }, A = (b) => {
    const x = b.target.getBoundingClientRect();
    return {
      x: (b.clientX - x.left) / x.width * Se,
      y: (b.clientY - x.top) / x.height * Le
    };
  }, B = J(() => {
    var x;
    const b = (x = d.current) == null ? void 0 : x.toDataURL("image/png");
    b && u(o, b);
  }, [o, u]), C = () => {
    const b = w();
    b && (b.clearRect(0, 0, Se, Le), N(!1), u(o, null));
  };
  return T(() => {
    const b = w();
    b && (b.lineWidth = 2, b.lineCap = "round", b.strokeStyle = "#111");
  }, []), /* @__PURE__ */ v("div", { className: "survey-question survey-question--signature", children: [
    /* @__PURE__ */ v("div", { className: "survey-question__label", children: [
      m(c, t, r.defaultLocale),
      g && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    p && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(p, t, r.defaultLocale) }),
    /* @__PURE__ */ n(
      "canvas",
      {
        ref: d,
        className: "survey-question__signature-canvas",
        width: Se,
        height: Le,
        role: "img",
        "aria-label": "signature pad",
        onPointerDown: (b) => {
          b.target.setPointerCapture(b.pointerId);
          const x = w();
          if (!x) return;
          const { x: D, y: z } = A(b);
          x.beginPath(), x.moveTo(D, z), a(!0);
        },
        onPointerMove: (b) => {
          if (!y) return;
          const x = w();
          if (!x) return;
          const { x: D, y: z } = A(b);
          x.lineTo(D, z), x.stroke(), N(!0);
        },
        onPointerUp: () => {
          a(!1), _ && B();
        }
      }
    ),
    /* @__PURE__ */ n("div", { className: "survey-question__signature-actions", children: /* @__PURE__ */ n("button", { type: "button", className: "survey-button survey-button--ghost", onClick: C, children: l.clearSignature }) })
  ] });
}
function Xt({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u, ui: l } = R(), o = e.id, c = e.title, p = e.help, g = !!e.required, d = e.yesLabel, y = e.noLabel, a = i[o], _ = d ? m(d, t, r.defaultLocale) : l.yes, N = y ? m(y, t, r.defaultLocale) : l.no;
  return /* @__PURE__ */ v("fieldset", { className: "survey-question survey-question--yesno", children: [
    /* @__PURE__ */ v("legend", { className: "survey-question__label", children: [
      m(c, t, r.defaultLocale),
      g && /* @__PURE__ */ n("span", { "aria-label": "required", className: "survey-question__required", children: " *" })
    ] }),
    p && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(p, t, r.defaultLocale) }),
    /* @__PURE__ */ v("div", { className: "survey-question__yesno", role: "radiogroup", children: [
      /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          role: "radio",
          "aria-checked": a === !0,
          className: "survey-question__yesno-button" + (a === !0 ? " survey-question__yesno-button--selected" : ""),
          onClick: () => u(o, !0),
          children: _
        }
      ),
      /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          role: "radio",
          "aria-checked": a === !1,
          className: "survey-question__yesno-button" + (a === !1 ? " survey-question__yesno-button--selected" : ""),
          onClick: () => u(o, !1),
          children: N
        }
      )
    ] })
  ] });
}
const Kt = ["en", "ar", "ku", "ru"], xe = /* @__PURE__ */ new WeakMap();
function en({ question: e }) {
  const { locale: t, schema: r, answers: i, setAnswer: u, answerContext: l } = R(), o = e.id, c = e.title, p = e.help, g = !!e.required, d = i[o] ?? "", y = (L, se = "queryValue") => vt(String(e[L] ?? ""), l, t, se).trim(), a = y("calendarApi", "url"), _ = y("branchId"), N = y("brandId"), w = [...new Set(y("departmentId").split(",").map((L) => L.trim()).filter(Boolean))], A = w.length === 1 ? w[0] : "", B = w.length > 1 ? w : void 0, C = w.length ? "" : [...new Set(y("services").split(",").map((L) => L.trim()).filter(Boolean))].join(","), b = [a, _, w.join(","), C, N].join(`
`), x = Kt.includes(t.slice(0, 2)) ? t.slice(0, 2) : "en", D = m(c, t, r.defaultLocale), z = xe.get(r) ?? /* @__PURE__ */ new Map();
  xe.has(r) || xe.set(r, z), T(() => {
    const L = z.get(o);
    d && L !== void 0 && L !== b && (z.delete(o), u(o, null));
  }, [b]);
  const E = j(null);
  return T(() => {
    const L = E.current;
    L && (L.calendarApi = a, L.branchId = _, L.departmentId = A, L.departmentIds = B, L.services = C, L.brandId = N, L.language = x, L.label = D, L.isRequired = g, L.showStatus = !0, L.showToday = !1, L.hourCycle = "h12", L.defaultValue = z.get(o) === b ? d : "");
  }, [a, _, b, x, D, g]), T(() => {
    const L = E.current;
    if (!L) return;
    const se = (q) => {
      const Z = q.detail;
      z.set(o, b), u(o, (Z == null ? void 0 : Z.value) || null);
    };
    return L.addEventListener("slotChange", se), () => L.removeEventListener("slotChange", se);
  }, [o, b, u]), /* @__PURE__ */ v("div", { className: "survey-question survey-question--booking-slot", children: [
    /* @__PURE__ */ v("div", { className: "survey-question__label", "aria-hidden": "true", children: [
      D,
      g && /* @__PURE__ */ n("span", { className: "survey-question__required", children: " *" })
    ] }),
    p && /* @__PURE__ */ n("p", { className: "survey-question__help", children: m(p, t, r.defaultLocale) }),
    /* @__PURE__ */ n("shift-booking-calendar", { id: `q-${o}`, ref: E })
  ] });
}
function tn(e, t) {
  switch (e.code) {
    case "minLength":
      return K(t.minLengthError, e.params);
    case "maxLength":
      return K(t.maxLengthError, e.params);
    case "pattern":
      return t.patternError;
    case "min":
      return K(t.minError, e.params);
    case "max":
      return K(t.maxError, e.params);
    case "range":
      return K(t.rangeError, e.params);
    case "minSelected":
      return K(t.minSelectedError, e.params);
    case "maxSelected":
      return K(t.maxSelectedError, e.params);
    default:
      return t.invalidAnswerError;
  }
}
const nn = {
  text: Dt,
  paragraph: jt,
  number: zt,
  rating: Mt,
  nps: Pt,
  singleChoice: Ht,
  multiChoice: Ut,
  dropdown: Wt,
  date: Yt,
  dateTime: Gt,
  bookingSlot: en,
  file: Jt,
  signature: Zt,
  yesNo: Xt,
  navigationList: Vt
};
function ze(e, t, r) {
  const i = e.screens.find((l) => l.id === t);
  return !i || (i.questions ?? []).length > 0 ? !1 : me(e, t, r).kind === "end";
}
function rn(e) {
  switch (e == null ? void 0 : e.code) {
    case "conflict":
      return "answered";
    case "gone":
      return "closed";
    case "badRequest":
    case "notFound":
      return "failed";
    default:
      return "retry";
  }
}
function dn({
  schema: e,
  onSubmit: t,
  initialAnswers: r,
  locale: i,
  onLocaleChange: u,
  showLocalePicker: l,
  onScreenChange: o,
  onCompleted: c,
  onSubmitError: p,
  registry: g,
  submissionMeta: d,
  uiLocales: y,
  resumeKey: a,
  storage: _,
  emitHostMessages: N,
  hostMessageOrigin: w,
  hostMessageTarget: A,
  activeScreenId: B,
  activeScreenJumpToken: C
}) {
  var De, Pe, Ve;
  const [b, x] = F(null), D = i ?? e.defaultLocale ?? "en", E = b !== null && (((De = e.locales) == null ? void 0 : De.includes(b)) ?? !1) ? b : D, L = j(D);
  T(() => {
    L.current !== D && (L.current = D, x(null));
  }, [D]);
  const se = g ?? nn, q = G(
    () => Ct(E, e.defaultLocale, y),
    [E, e.defaultLocale, y]
  ), Z = e.locales ?? [], Ue = l ?? Z.length > 1, We = J(
    (s) => {
      x(s), u == null || u(s);
    },
    [u]
  ), X = _ ?? (typeof globalThis < "u" ? globalThis.localStorage : void 0), U = G(() => {
    var S;
    if (!a || !X) return null;
    const s = It(X, a);
    return s ? s.currentScreenId === null || e.screens.some((k) => k.id === s.currentScreenId) ? !s.history && s.currentScreenId ? { ...s, history: pt(e, s.answers, s.currentScreenId) ?? [] } : s : { ...s, currentScreenId: ((S = e.screens[0]) == null ? void 0 : S.id) ?? null, history: [] } : null;
  }, []), [V, Ye] = F(() => ({
    ...r ?? {},
    ...(U == null ? void 0 : U.answers) ?? {}
  })), [f, ie] = F(
    () => {
      var s;
      return (U == null ? void 0 : U.currentScreenId) ?? ((s = e.screens[0]) == null ? void 0 : s.id) ?? null;
    }
  ), [M, ge] = F(() => (U == null ? void 0 : U.history) ?? []);
  T(() => {
    if (e.screens.length === 0) {
      f !== null && ie(null);
      return;
    }
    f !== null && e.screens.some((h) => h.id === f) || ie(e.screens[0].id);
  }, [e, f]);
  const [ee, Ee] = F(!1), [I, _e] = F(null), W = (I == null ? void 0 : I.kind) === "answered" || (I == null ? void 0 : I.kind) === "closed", be = j(null), [Ge, ae] = F(/* @__PURE__ */ new Set()), [Je, ce] = F(/* @__PURE__ */ new Set()), [H, Ze] = F(!1), Ae = j(void 0);
  T(() => {
    if (B === void 0) return;
    const s = `${C ?? ""}:${B ?? ""}`;
    Ae.current !== s && (Ae.current = s, !(B === null || H) && e.screens.some((h) => h.id === B) && (ae(/* @__PURE__ */ new Set()), ce(/* @__PURE__ */ new Set()), ge((h) => {
      const S = h.indexOf(B);
      return S >= 0 ? h.slice(0, S) : f && f !== B ? [...h, f] : h;
    }), ie(B)));
  }, [B, C, e, H, f]);
  const Xe = j((/* @__PURE__ */ new Date()).toISOString()), te = j(null);
  if (te.current === null) {
    const s = {};
    A !== void 0 && (s.target = A), w !== void 0 && (s.targetOrigin = w), N !== void 0 && (s.enabled = N), te.current = Bt(s);
  }
  const P = G(
    () => f ? e.screens.find((s) => s.id === f) ?? null : null,
    [e, f]
  ), Ce = G(() => {
    const s = /* @__PURE__ */ new Map();
    for (const h of e.screens)
      for (const S of h.questions ?? []) {
        const k = S.id;
        typeof k == "string" && s.set(k, h.id);
      }
    return s;
  }, [e]), O = G(() => {
    const s = new Set(M);
    f && s.add(f);
    const h = {};
    for (const [S, k] of Object.entries(V)) {
      const $ = Ce.get(S);
      ($ === void 0 || s.has($)) && (h[S] = k);
    }
    return h;
  }, [V, M, f, Ce]), Ne = j(/* @__PURE__ */ new Map()), [Ke, et] = F(0), Te = J((s, h) => {
    Ne.current.get(s) !== h && (Ne.current.set(s, h), et((S) => S + 1));
  }, []), ue = G(
    () => ht({
      schema: e,
      answers: O,
      lookupOptions: (s) => Ne.current.get(s),
      yesNoLabels: { yes: q.strings.yes, no: q.strings.no }
    }),
    // sourcedVersion is the change signal for the ref-held map.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, O, q.strings.yes, q.strings.no, Ke]
  ), Q = G(
    () => P ? mt(P, ue) : null,
    [P, ue]
  );
  T(() => {
    var s;
    o == null || o(f), (s = te.current) == null || s.screenChanged(f);
  }, [f, o]);
  const Re = j(!1);
  T(() => {
    var s;
    Re.current || !f || (Re.current = !0, (s = te.current) == null || s.loaded());
  }, [f]), T(() => {
    !a || !X || H || W || Ot(X, a, {
      answers: V,
      currentScreenId: f,
      history: [...M],
      schemaVersion: e.version
    });
  }, [V, f, M, a, X, H, W, e.version]), T(() => {
    (H || W) && a && X && Qt(X, a);
  }, [H, W, a, X]), T(() => {
    var s;
    I && ((s = te.current) == null || s.error(I.message));
  }, [I]);
  const de = J((s, h) => {
    Ye((S) => ({ ...S, [s]: h }));
  }, []), ye = J(
    (s) => {
      s !== null && (ae(/* @__PURE__ */ new Set()), ce(/* @__PURE__ */ new Set()), f && f !== s && ge((h) => [...h, f]), ie(s));
    },
    [f]
  ), tt = J(() => {
    let s = M.length - 1;
    for (; s >= 0 && !e.screens.some((S) => S.id === M[s]); ) s--;
    if (s < 0) return;
    const h = M[s];
    ae(/* @__PURE__ */ new Set()), ce(/* @__PURE__ */ new Set()), _e(null), be.current = null, ge(M.slice(0, s)), ie(h);
  }, [M, e]), nt = M.some((s) => e.screens.some((h) => h.id === s)), we = J(
    (s) => {
      if (!s.required) return !1;
      const h = V[s.id];
      return !!(h == null || typeof h == "string" && h.trim() === "" || Array.isArray(h) && h.length === 0);
    },
    [V]
  ), ne = J(async () => {
    var s;
    Ee(!0), _e(null);
    try {
      await t({
        schemaVersion: e.version ?? 0,
        answers: O,
        meta: {
          startedAt: (d == null ? void 0 : d.startedAt) ?? Xe.current,
          completedAt: (d == null ? void 0 : d.completedAt) ?? (/* @__PURE__ */ new Date()).toISOString(),
          ...d ?? {}
        }
      }), Ze(!0), c == null || c(f), (s = te.current) == null || s.completed({ screenId: f, answers: O });
    } catch (h) {
      _e({ kind: rn(h), message: (h == null ? void 0 : h.message) ?? String(h) }), p == null || p(h);
    } finally {
      Ee(!1);
    }
  }, [e.version, O, d, t, c, p, f]), rt = J(() => {
    if (!f) return;
    const s = e.screens.find((Y) => Y.id === f), S = ((s == null ? void 0 : s.questions) ?? []).filter(we).map((Y) => Y.id);
    if (S.length > 0) {
      ae(new Set(S));
      return;
    }
    const k = ft(s == null ? void 0 : s.questions, V);
    if (k.length > 0) {
      ce(new Set(k.map((Y) => Y.questionId)));
      return;
    }
    const $ = me(e, f, O);
    $.kind === "end" ? ne() : ye($.screenId);
  }, [e, f, V, O, we, ye, ne]);
  T(() => {
    if (H || W || ee || !f || !P || be.current === f || !(!P.questions || P.questions.length === 0)) return;
    me(e, f, O).kind === "end" && (be.current = f, ne());
  }, [f, P, H, W, ee, e, O, ne]);
  const re = j(null);
  T(() => {
    const s = re.current;
    if (!s || typeof ResizeObserver > "u") return;
    const h = new ResizeObserver((S) => {
      var $;
      const k = S[0];
      k && (($ = te.current) == null || $.resize(Math.ceil(k.contentRect.height)));
    });
    return h.observe(s), () => h.disconnect();
  }, []), T(() => {
    const s = re.current;
    if (!s) return;
    const h = (S) => {
      const k = S.detail;
      if (!k || !f) return;
      de(k.questionId, k.option.id);
      const $ = { ...O, [k.questionId]: k.option.id }, Y = _t(
        k.option,
        e,
        f,
        $
      );
      Y.kind === "end" ? ne() : ye(Y.screenId);
    };
    return s.addEventListener("survey:navigationListSelect", h), () => s.removeEventListener("survey:navigationListSelect", h);
  }, [O, f, e, de, ye, ne]);
  const st = G(
    () => ({
      schema: e,
      locale: E,
      direction: q.direction,
      ui: q.strings,
      answers: V,
      setAnswer: de,
      answerContext: ue,
      registerSourcedOptions: Te
    }),
    [e, E, q, V, de, ue, Te]
  ), le = G(() => wt(e.branding), [e.branding]), Be = (Pe = e.branding) != null && Pe.logoUrl ? /* @__PURE__ */ n("div", { className: "survey-brand", children: /* @__PURE__ */ n(
    "img",
    {
      className: "survey-brand__logo",
      src: e.branding.logoUrl,
      alt: "",
      onError: (s) => {
        s.currentTarget.parentElement.style.display = "none";
      }
    }
  ) }) : null, it = Z.includes(E) ? Z : [E, ...Z], Ie = Ue ? /* @__PURE__ */ v("label", { className: "survey-locale", children: [
    /* @__PURE__ */ n("span", { className: "survey-locale__icon", "aria-hidden": "true", children: /* @__PURE__ */ v("svg", { viewBox: "0 0 24 24", width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "1.8", children: [
      /* @__PURE__ */ n("circle", { cx: "12", cy: "12", r: "9" }),
      /* @__PURE__ */ n("path", { d: "M3 12h18M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18" })
    ] }) }),
    /* @__PURE__ */ n("span", { className: "survey-locale__code", "aria-hidden": "true", children: E.toUpperCase() }),
    /* @__PURE__ */ n(
      "select",
      {
        className: "survey-locale__select",
        "aria-label": q.strings.language,
        value: E,
        onChange: (s) => We(s.target.value),
        children: it.map((s) => /* @__PURE__ */ n("option", { value: s, children: At(s) }, s))
      }
    )
  ] }) : null, lt = (P == null ? void 0 : P.questions) ?? [], Oe = P !== null && lt.length === 0 && !P.nextScreen, ve = !H && !W && nt && !ee && (!Oe || I !== null), Qe = e.screens.length > 1 ? /* @__PURE__ */ n(
    "button",
    {
      type: "button",
      className: ve ? "survey-back" : "survey-back survey-back--hidden",
      "aria-label": q.strings.back,
      "aria-hidden": !ve,
      tabIndex: ve ? void 0 : -1,
      onClick: tt,
      children: /* @__PURE__ */ n(
        "svg",
        {
          className: "survey-back__icon",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2.2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          "aria-hidden": "true",
          children: /* @__PURE__ */ n("path", { d: "M15 5l-7 7 7 7" })
        }
      )
    }
  ) : null, oe = Be || Ie || Qe ? /* @__PURE__ */ v("div", { className: ve ? "survey-chrome survey-chrome--back" : "survey-chrome", children: [
    /* @__PURE__ */ n("div", { className: "survey-chrome__start", children: Qe }),
    Be,
    /* @__PURE__ */ n("div", { className: "survey-chrome__end", children: Ie })
  ] }) : null;
  if (H)
    return /* @__PURE__ */ v(
      "div",
      {
        ref: re,
        className: "survey-root survey-root--done",
        dir: q.direction,
        lang: E,
        style: le,
        children: [
          oe,
          /* @__PURE__ */ v("div", { className: "survey-screen survey-screen--enter", children: [
            /* @__PURE__ */ n("h2", { className: "survey-screen__title", children: Q != null && Q.title ? m(Q.title, E, e.defaultLocale) : q.strings.thankYou }),
            (Q == null ? void 0 : Q.description) && /* @__PURE__ */ n("p", { className: "survey-screen__description", children: m(Q.description, E, e.defaultLocale) })
          ] })
        ]
      }
    );
  if (W) {
    const s = I.kind === "answered";
    return /* @__PURE__ */ v(
      "div",
      {
        ref: re,
        className: "survey-root survey-root--done",
        dir: q.direction,
        lang: E,
        style: le,
        children: [
          oe,
          /* @__PURE__ */ v("div", { className: "survey-screen survey-screen--enter", role: "status", children: [
            /* @__PURE__ */ n("h2", { className: "survey-screen__title", children: s ? q.strings.alreadyAnsweredTitle : q.strings.surveyClosedTitle }),
            /* @__PURE__ */ n("p", { className: "survey-screen__description", children: s ? q.strings.alreadyAnsweredBody : q.strings.surveyClosedBody })
          ] })
        ]
      }
    );
  }
  const $e = I && !W ? /* @__PURE__ */ v("div", { className: "survey-screen__error survey-screen__error--enter", role: "alert", children: [
    /* @__PURE__ */ n("p", { className: "survey-screen__error-text", children: I.kind === "retry" ? q.strings.submitRetryError : q.strings.submitFailedError }),
    I.kind === "retry" && /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        className: "survey-button survey-button--retry",
        disabled: ee,
        onClick: () => void ne(),
        children: ee ? q.strings.submitting : q.strings.retry
      }
    )
  ] }) : null;
  if (!P || !Q)
    return /* @__PURE__ */ v("div", { ref: re, className: "survey-root", dir: q.direction, lang: E, style: le, children: [
      oe,
      /* @__PURE__ */ n("div", { className: "survey-screen", children: /* @__PURE__ */ n("em", { children: q.strings.noScreens }) })
    ] });
  if (f !== null && ze(e, f, O))
    return /* @__PURE__ */ v("div", { ref: re, className: "survey-root", dir: q.direction, lang: E, style: le, children: [
      oe,
      /* @__PURE__ */ n("div", { className: "survey-screen survey-screen--enter", children: $e ?? /* @__PURE__ */ n("p", { className: "survey-screen__sending", role: "status", children: q.strings.sendingAnswers }) })
    ] });
  const pe = Q.questions ?? [], Fe = !(pe.length > 0 && ((Ve = pe[pe.length - 1]) == null ? void 0 : Ve.type) === "navigationList") && !Oe, he = Fe && f !== null ? me(e, f, O) : null, ot = he !== null && (he.kind === "end" || he.kind === "screen" && ze(e, he.screenId, O));
  return /* @__PURE__ */ n(qt, { value: st, children: /* @__PURE__ */ v("div", { ref: re, className: "survey-root", dir: q.direction, lang: E, style: le, children: [
    oe,
    /* @__PURE__ */ v("div", { className: "survey-screen", children: [
      Q.title && /* @__PURE__ */ n("h2", { className: "survey-screen__title", children: m(Q.title, E, e.defaultLocale) }),
      Q.description && /* @__PURE__ */ n("p", { className: "survey-screen__description", children: m(Q.description, E, e.defaultLocale) }),
      /* @__PURE__ */ n("div", { className: "survey-screen__questions", children: pe.map((s, h) => {
        const S = s.id, k = S !== void 0 && Ge.has(S) && we(s), $ = !k && S !== void 0 && Je.has(S) && V[S] != null ? gt(s, V[S])[0] ?? null : null;
        return /* @__PURE__ */ v("div", { className: k || $ !== null ? "survey-question-slot survey-question-slot--invalid" : "survey-question-slot", children: [
          /* @__PURE__ */ n(Ft, { question: s, registry: se }),
          k && /* @__PURE__ */ n("p", { className: "survey-question__required-error", role: "alert", children: q.strings.requiredError }),
          $ && /* @__PURE__ */ n("p", { className: "survey-question__required-error", role: "alert", children: tn($, q.strings) })
        ] }, S ?? h);
      }) }),
      Fe && /* @__PURE__ */ n("div", { className: "survey-screen__actions", children: /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          className: "survey-button survey-button--primary",
          disabled: ee,
          onClick: rt,
          children: ee ? q.strings.submitting : ot ? q.strings.submit : q.strings.next
        }
      ) }),
      $e
    ] })
  ] }) });
}
export {
  en as BookingSlotQuestion,
  Yt as DateQuestion,
  Gt as DateTimeQuestion,
  Wt as DropdownQuestion,
  Jt as FileQuestion,
  Tt as HOST_MESSAGE_SOURCE,
  Rt as HOST_MESSAGE_VERSION,
  Ut as MultiChoiceQuestion,
  Vt as NavigationListQuestion,
  Pt as NpsQuestion,
  zt as NumberQuestion,
  jt as ParagraphQuestion,
  Ft as QuestionHost,
  Mt as RatingQuestion,
  Zt as SignatureQuestion,
  Ht as SingleChoiceQuestion,
  $t as SourcedOptionsGate,
  dn as SurveyRenderer,
  Dt as TextQuestion,
  Xt as YesNoQuestion,
  kt as builtInLocales,
  Qt as clearResumeState,
  un as clearSourcedOptionsCache,
  Bt as createHostBridge,
  nn as defaultRegistry,
  It as loadResumeState,
  m as localize,
  Ct as resolveLocaleConfig,
  Ot as saveResumeState,
  ke as storageKey,
  R as useSurveyContext
};
//# sourceMappingURL=index.js.map
